import {MyDataReferenceTableConfig} from "../types/MyDataReferenceTable";

export const myDataReferenceTables: MyDataReferenceTableConfig[] = [
    {
        key: 'invoice-types',
        title: 'mydata_invoice_types',
        searchPlaceholder: 'Search invoice types...',
        fields: [
            {key: 'invoice_type', label: 'invoice_type', type: 'text', required: true},
            {key: 'invoice_type_description', label: 'invoice_type_description', type: 'text', required: true},
        ],
    },
    {
        key: 'move-types',
        title: 'mydata_move_types',
        searchPlaceholder: 'Search move types...',
        fields: [
            {key: 'code', label: 'code', type: 'number', required: true},
            {key: 'description', label: 'description', type: 'text', required: true},
        ],
    },
    {
        key: 'payment-methods',
        title: 'mydata_payment_methods',
        searchPlaceholder: 'Search payment methods...',
        fields: [
            {key: 'code', label: 'code', type: 'number', required: true},
            {key: 'description', label: 'description', type: 'text', required: true},
        ],
    },
    {
        key: 'quantity-types',
        title: 'mydata_quantity_types',
        searchPlaceholder: 'Search quantity types...',
        fields: [
            {key: 'code', label: 'code', type: 'number', required: true},
            {key: 'description', label: 'description', type: 'text', required: true},
        ],
    },
    {
        key: 'transportation-purposes',
        title: 'mydata_transportation_purposes',
        searchPlaceholder: 'Search transportation purposes...',
        fields: [
            {key: 'code', label: 'code', type: 'number', required: true},
            {key: 'description', label: 'description', type: 'text', required: true},
        ],
    },
    {
        key: 'vat-categories',
        title: 'mydata_vat_categories',
        searchPlaceholder: 'Search VAT categories...',
        fields: [
            {key: 'code', label: 'code', type: 'number', required: true},
            {key: 'description', label: 'description', type: 'text', required: true},
            {key: 'display_vat', label: 'display_vat', type: 'text', required: true},
        ],
    },
];

export const getMyDataReferenceTableConfig = (key?: string) => {
    return myDataReferenceTables.find((table) => table.key === key);
};
